import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';

@Injectable()
export class LazyLoadingScriptService {
  _loadedLibraries: { [url: string]: ReplaySubject<any> } = {};

  constructor(@Inject(DOCUMENT) private readonly document: any) {}

  loadScript(url: string): Observable<any> {
    if (this._loadedLibraries[url]) {
      return this._loadedLibraries[url].asObservable();
    }

    this._loadedLibraries[url] = new ReplaySubject();

    const script = this.document.createElement('script');
    script.type = 'text/javascript';
    script.src = url;

    script.onload = () => {
      // todo: check
      // this._loadedLibraries[url].next();
      this._loadedLibraries[url].next({});
      this._loadedLibraries[url].complete();
    };

    this.document.head.appendChild(script);

    return this._loadedLibraries[url].asObservable();
  }
}
